import { tm } from '../tm'
import type { Project } from '@captaincause/types'
import type { CSSProperties } from 'react'

interface ProjectKeyNumbersProps {
  project: Project
  className?: string
  style?: CSSProperties
}

const emptyObj = {}
export const ProjectKeyNumbers = ({
  project,
  className = '',
  style = emptyObj,
}: ProjectKeyNumbersProps) => {
  if (!project.key_numbers || project.key_numbers.length === 0) return null

  return (
    <div
      className={tm(
        'flex w-full flex-wrap justify-center gap-x-8 gap-y-10 lg:gap-x-10 xl:gap-x-14',
        className,
      )}
      style={style}
    >
      {project.key_numbers.slice(0, 3).map(keyNumber => (
        <div
          key={keyNumber.value}
          className="flex flex-col items-center text-dark-gray sm:flex-1 sm:items-start"
        >
          <div
            className={tm(
              'flex flex-wrap items-center',
              keyNumber.unit &&
                keyNumber.unit.length > 3 &&
                'flex-col items-center sm:items-start',
            )}
          >
            <div
              className={tm(
                'p-1 pl-0 pt-0 font-title text-4xl font-extrabold text-black',
                keyNumber.unit && keyNumber.unit.length > 3 && 'inline',
              )}
            >
              {keyNumber.value}
            </div>
            {keyNumber.unit ? (
              <span className="text-sm">{keyNumber.unit}</span>
            ) : null}
          </div>

          <div className="mt-3 flex flex-1 items-start">
            <div className="line-clamp-5 text-left text-sm leading-6">
              {keyNumber.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
